import React from 'react'
import { cn } from '../../lib/utils'

// CSS-shimmer block primitive. Use width/height utilities on className to
// match the eventual content's footprint (e.g. h-24 w-full for a card,
// h-4 w-32 for a line of text).
export function Skeleton({ className, ...rest }) {
  return (
    <div
      aria-hidden="true"
      className={cn(
        'animate-pulse rounded-md bg-muted/70 dark:bg-muted/40',
        className
      )}
      {...rest}
    />
  )
}
